export class AtomParserService {
    parse(response) {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(response.data, 'application/xml');
        const entries = Array.from(xmlDoc.getElementsByTagName('entry'));
        return entries.map((entry) => {
            const id = entry.getElementsByTagName('id')[0]?.textContent || '';
            const title = entry.getElementsByTagName('title')[0]?.textContent || '';
            const link = entry.getElementsByTagName('link')[0]?.getAttribute('href') || '';
            const summary = entry.getElementsByTagName('summary')[0]?.textContent || '';
            const published = entry.getElementsByTagName('published')[0]?.textContent || '';
            return { id, title, link, summary, published };
        });
    }
}
